<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
import Vue from "vue";
export default {
    name: "App",
    components: {},
    updated() {
        if (
            !localStorage.token &&
            this.$route.path !== "/" &&
            this.$route.path !== "/reset"
        ) {
            console.log("App redirecting, params: ", this.$route.query);
            if (this.$route.query && this.$route.query.id) {
                console.log("App Writing redirection: " + this.$route.query.id)
                localStorage.redirect = this.$route.query.id;
            }
            this.$router.push("/?redirect=" + this.$route.path);
        }
    },
    data() {
        return {};
    },
    created() {
        if (1 || this.$branded) {
            console.log("VUE Version: " + Vue.version);
            document.title = "Vonage IDS";
            require("@vonagevolta/volta2/dist/css/volta.css");
            require("@vonagevolta/volta2/dist/css/addons/volta-prism.css");
            require("@vonagevolta/volta2/dist/css/volta-templates.css");
            require("@vonagevolta/volta2/dist/symbol/volta-icons.svg");
        } else {
            require("@vonagevolta/volta2/dist/css/volta.css");
            require("@vonagevolta/volta2/dist/css/addons/volta-prism.css");
            require("@vonagevolta/volta2/dist/css/volta-templates.css");
            require("@vonagevolta/volta2/dist/symbol/volta-icons.svg");
        }
    },
};

import axios from "axios";
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 0px;
}
</style>
